import React, { useEffect, useState, useCallback } from "react";

import Navbar from "../components/Navbar";
import Header from "./Header";
// import "./Header.css";
import "./MyBookings.css";

import moment from "moment";

import { Link, useNavigate } from "react-router-dom";
import host from "../config";
const MyBookings = () => {
  const navigate = useNavigate();

  // let host = "https://api.vmrdarental.com";
  // let host = "https://api.vmrdarental.com";
  const [paginatedBookingList, setPaginatedBookingList] = useState([]);

  const [noData, setNoData] = useState();
  const [bookingData, setBookingData] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [statusCheck, setStatusCheck] = useState(false);
  const [isShow, invokeModal] = React.useState(false);
  const [editableRoom, setEditableRoom] = React.useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [showPopup, setShowPopup] = useState(false);
  // const [cancellationReason, setCancellationReason] = useState("");
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [cancellationReason, setCancellationReason] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [alertShown, setAlertShown] = useState(false); // State to track alert display

  const [selectedRI, setSelectedRI] = useState(""); // Stores selected RI value
  const [selectedBookingId, setSelectedBookingId] = useState(null); // Stores the booking ID
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // const [selectedBooking, setSelectedBooking] = useState(null);
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [discountReason, setDiscountReason] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  //  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const openModal = (booking) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
    setIsChecked(false);
  };

  const [refundReason, setRefundReason] = useState("");
  const [calculatedDiscount, setCalculatedDiscount] = useState(0); // ✅ Fix: Define state variable
  const [refundPercentage, setRefundPercentage] = useState(0);
  const [calculatedRefund, setCalculatedRefund] = useState(0);
  const [showRefundModal, setShowRefundModal] = useState(false);
  // const handleProcessRefund = () => {
  //   if (!selectedBooking) return;

  //   // Calculate final refund amount (refund + security deposit)
  //   const totalRefund =
  //     calculatedRefund + selectedBooking.total_security_deposit;

  //   // Example: Send refund details to backend
  //   const refundData = {
  //     bookingId: selectedBooking.id,
  //     refundPercentage,
  //     refundAmount: calculatedRefund,
  //     securityDeposit: selectedBooking.total_security_deposit,
  //     totalRefund,
  //     refundReason,
  //   };

  //   console.log("Processing Refund:", refundData);

  //   // TODO: Send data to backend API (replace with actual API call)
  //   // axios.post("/api/process-refund", refundData)
  //   //   .then(response => console.log("Refund successful", response))
  //   //   .catch(error => console.error("Refund failed", error));

  //   // Close modal after processing refund
  //   setShowRefundModal(false);
  // };

  // Fetch user role from localStorage

  const handleProcessRefund = () => {
    if (!selectedBooking || !refundReason) {
      alert("Please select a booking and enter a reason.");
      return;
    }

    const payload = {
      booking_group_id: selectedBooking.booking_group_id, // Ensure correct field
      sec_remarks: refundReason,
      added_by: userRole, // Ensure this is a valid user ID
    };

    console.log("🔹 Sending Payload:", payload); // Debugging

    fetch(`${host}/update-post-booking-details-com`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("✅ Response from API:", data);
        if (data.message) {
          // alert("Refund Approved Successfully!");
          alert("Verified and Assigned to CAO");
          setShowDiscountModal(false);
          myBookingsList(); // Refresh booking list
        } else {
          alert("Error: " + data.error);
        }
      })
      .catch((err) => {
        console.error("❌ Error:", err);
        alert("Something went wrong!");
      });
  };

  useEffect(() => {
    if (selectedBooking) {
      setCalculatedRefund(selectedBooking.refund_amount || 0);
    }
  }, [selectedBooking]);

  const openDiscountModal = (booking) => {
    setSelectedBooking(booking);
    setDiscountPercentage("");
    setDiscountReason("");
    setShowDiscountModal(true);
  };

  const openPopup = (bookingGroupId) => {
    setSelectedBookingId(bookingGroupId); // Store the ID for API call
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedRI(""); // Reset selection
  };

  const handleApproval = async () => {
    if (!selectedRI) {
      alert("Please select an RI value before approving.");
      return;
    }

    try {
      console.log(" Sending request:", selectedBookingId, selectedRI);

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBookingId,
          ri_value: selectedRI,
        }),
      });

      console.log(" Waiting for response...");

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();
      console.log("✅ API Response:", updatedBooking);

      if (updatedBooking.success) {
        alert("Venue successfully approved!");
        myBookingsList(); // Refresh data
        closePopup(); // Close modal
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error(" Error approving booking:", error);
    }
  };

  const handleCancelClick = (booking) => {
    const cancellationReason = prompt("Please enter a cancellation reason:");

    if (!cancellationReason) {
      alert("Cancellation reason is required.");
      return;
    }

    cancelBooking(
      booking.booking_group_id,
      booking.date,
      cancellationReason
    ).then((success) => {
      if (success) {
        // Update UI only when the cancellation is successful
        setPaginatedBookingList((prevList) =>
          prevList.map((b) =>
            b.booking_group_id === booking.booking_group_id
              ? {
                  ...b,
                  status: "2",
                  cancelDisabled: true,
                  cancellation_reason: cancellationReason,
                }
              : b
          )
        );
           myBookingsList();
      }
    });
  };

  const handleCancelClick1 = (item) => {
    setSelectedItem(item); // Set the selected booking
    setShowCancelModal(true);
  };

  const cancelBooking = async (
    bookingGroupId,
    bookingDate,
    cancellationReason
  ) => {
    let userRole = localStorage.getItem("userRole");

    if (!userRole) {
      console.error("User type not found in localStorage");
      alert("User type not found. Please log in again.");
      return false;
    }

    userRole = parseInt(userRole, 10);

    console.log("Cancel Booking Request:", {
      bookingGroupId,
      bookingDate,
      cancellationReason,
      userRole,
    });

    try {
      const response = await fetch(
        `${host}/cancelBooking?bookingGroupId=${bookingGroupId}&reason=${encodeURIComponent(
          cancellationReason
        )}&userRole=${userRole}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );

      const data = await response.json();
      console.log("Server Response:", data);

      if (response.ok) {
        alert(data.message);
        return true; // Indicate success
      } else {
        alert("Cancellation failed: " + data.message);
        return false;
      }
    } catch (error) {
      console.error("Cancellation Error:", error);
      alert("Cancellation failed. Please try again later.");
      return false;
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setCancellationReason("");
    setSelectedBooking(null);
  };

  const handleModalSubmit = () => {
    if (!cancellationReason.trim()) {
      alert("Please provide a reason for cancellation.");
      return;
    }

    console.log("Cancellation reason:", cancellationReason); // Debugging
    cancelBooking(
      selectedBooking.booking_group_id,
      selectedBooking.date,
      cancellationReason
    );
    handleModalClose();
  };

  const handleApprove = async (bookingGroupId) => {
    if (!isChecked) {
      alert("Please confirm the details before approving.");
      return;
    }

    console.log("Approved Booking:", selectedBooking);

    try {
      console.log("Sending booking_group_id:", bookingGroupId); // Debugging

      const response = await fetch(`${host}/approveBooking`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({ booking_group_id: bookingGroupId }), // Send in the body
      });

      if (!response.ok) {
        throw new Error("Failed to approve booking");
      }

      const updatedBooking = await response.json();

      if (updatedBooking.success) {
        alert("Venue successfully approved!"); // Show alert

        // 🔄 Re-fetch latest booking data after approval
        myBookingsList();

        closeModal();
      } else {
        throw new Error("Approval failed");
      }
    } catch (error) {
      console.error("Error approving booking:", error);
    }
  };

  const handlePageChange = (newPage) => {
    console.log("Page changed to:", newPage);
    setCurrentPage(newPage);

    const newPaginatedBookingList = bookingList.slice(
      (newPage - 1) * itemsPerPage,
      newPage * itemsPerPage
    );

    setPaginatedBookingList(newPaginatedBookingList);
  };

  const myBookingsListCallback = useCallback(() => {
    // myBookingsList();
  }, []);

  useEffect(() => {
    if (
      !localStorage.getItem("access_token") ||
      localStorage.getItem("access_token") === ""
    ) {
      navigate("/", "_self");
    }

    myBookingsListCallback();
    myBookingsList();
  }, [currentPage, myBookingsListCallback]);

  let userRole = localStorage.getItem("userRole");
  let billingRequest = JSON.parse("{}");
  let srNo = 0;
  if (
    localStorage.getItem("access_token") == undefined ||
    localStorage.getItem("access_token") === ""
  ) {
    navigate("/", "_self");
  }

  // Add this inside your component function
  useEffect(() => {
    console.log("Booking List:", bookingList);
  }, [bookingList]);

  const summaryView = (booking_group_id) => {
    fetch(
      host +
        "/getBookingSummary?bookingGroupId=" +
        booking_group_id +
        "&access_token=" +
        localStorage.getItem("access_token") +
        "&time=" +
        Math.round(new Date().getTime() / 1000),
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      }
    ).then((response) => {
      response.json().then((rooms) => {
        if (rooms.length === 0) {
          console.error("No rooms found");
          return;
        }

        let bookingDetailsDataFinal = [];
        const orderId = rooms[0].order_id;
        console.log("Order ID:", orderId);

        billingRequest.locationId = rooms[0].location_id;
        billingRequest.name = rooms[0].customer_name;
        billingRequest.address = rooms[0].address;
        billingRequest.contactno = rooms[0].contact_no;
        billingRequest.email = rooms[0].email_id;
        billingRequest.pan = rooms[0].pan_number;
        billingRequest.aadhaar = rooms[0].aadhaar_number;
        billingRequest.razorpay_status = rooms[0].razorpay_status;
        billingRequest.orderId = rooms[0].booking_id;
        billingRequest.bookingId = rooms[0].order_id;
        billingRequest.is_approved = rooms[0].is_approved;

        rooms.map((row) => {
          let tmpBookingDetailsDataFinal = JSON.parse("{}");
          tmpBookingDetailsDataFinal["room_name"] = row.room_name;
          tmpBookingDetailsDataFinal["bookingDate"] = row.date;
          tmpBookingDetailsDataFinal["amount"] = row.sub_total;
          tmpBookingDetailsDataFinal["selectedPersons"] = row.extra_persons;
          tmpBookingDetailsDataFinal["finalGrandTotalVal"] = row.sub_total;

          bookingDetailsDataFinal.push(tmpBookingDetailsDataFinal);
          console.log("Row Sub Total:", row.sub_total);
        });

        billingRequest.roomData = bookingDetailsDataFinal;
        localStorage.setItem("billingRequest", JSON.stringify(billingRequest));
        localStorage.setItem("bookingDetailsData", JSON.stringify("{}"));

        navigate("/BookingSummary", {
          state: {
            orderId: rooms[0].order_id,
            isApproved: rooms[0].is_approved,
          },
        });
      });
    });
  };

  console.log("tmpBookingDetailsDataFinal");
  const handleViewDocument = (fileUrl) => {
    if (!fileUrl) {
      alert("Document URL is not available.");
      return;
    }

    // Open the document in a new tab
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  const myBookingsList = async () => {
    try {
      const response = await fetch(
        host +
          "/getMyBookingsList?access_token=" +
          localStorage.getItem("access_token") +
          "&time=" +
          Math.round(new Date().getTime() / 1000),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 403) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("access_token"); // Clear token
        navigate("/login", { replace: true }); // Redirect to login page
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch bookings");
      }

      const rooms = await response.json();
      console.log(rooms, "rooms");

      if (!Array.isArray(rooms)) {
        throw new Error("Invalid response format");
      }

      let bookingListArray = [];
      let bookingListTmp = {};

      if (rooms.length === 0) {
        setNoData("No booking details available");
      }

      rooms.forEach((row) => {
        // Group by booking_group_id and room_id
        const roomKey = `${row.booking_group_id}-${row.room_id}`;

        if (bookingListTmp[roomKey] !== undefined) {
          let tmp = bookingListTmp[roomKey];
          tmp.room_names = tmp.room_names + ", " + row.accommodation_type;

          // Ensure the sub_total is added only once for the room
          // Only add if the sub_total is not already set for this room in the group
          if (!tmp.sub_total) {
            tmp.sub_total = row.sub_total;
          }
          bookingListTmp[roomKey] = tmp;
        } else {
          row.room_names = row.room_names;
          // Set sub_total once for each room in the booking group
          row.sub_total = row.sub_total;
          bookingListTmp[roomKey] = row;
        }
      });

      // Convert the object to an array
      Object.keys(bookingListTmp).forEach((key) => {
        bookingListArray.push(bookingListTmp[key]);
      });

      const updatedBookingList = bookingListArray.map((booking) => {
        const checkOutDate = moment(booking.date);
        const currentDate = moment();
        const isDateCompleted = currentDate.isAfter(checkOutDate, "day");

        return {
          ...booking,
          cancelDisabled: booking.status === "Canceled" || isDateCompleted,
        };
      });

      setBookingList(updatedBookingList);

      const newTotalPageCount = Math.ceil(
        updatedBookingList.length / itemsPerPage
      );
      setTotalPageCount(newTotalPageCount);

      // Update the paginated list based on the current page
      const newPaginatedBookingList = updatedBookingList.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );

      setPaginatedBookingList(newPaginatedBookingList);

      console.log("Total Page Count:", newTotalPageCount);
      setAlertShown(false);
    } catch (error) {
      console.error("Error fetching bookings:", error);
      if (!alertShown) {
        alert(
          "There was an error fetching your bookings. Please try again later."
        );
        setAlertShown(true); // Set alert flag to prevent multiple alerts
      }
    }
  };

  const handleApplyDiscount = async () => {
    if (!discountPercentage || !discountReason) {
      alert("Please enter both discount percentage and reason.");
      return;
    }

    try {
      const response = await fetch(`${host}/applyDiscount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: selectedBooking.booking_group_id,
          discount_percentage: discountPercentage,
          reason: discountReason,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert("Discount applied successfully!");
        setShowDiscountModal(false);
        myBookingsList(); // Refresh bookings
      } else {
        alert("Failed to apply discount.");
      }
    } catch (error) {
      console.error("Error applying discount:", error);
    }
  };

 
  const handleRiChange = async (selectedRi, bookingGroupId) => {
    if (!selectedRi) return;

    try {
      const response = await fetch(`${host}/updateRoomBookingRI`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        body: JSON.stringify({
          booking_group_id: bookingGroupId,
          ri_value: selectedRi,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to update RI value.");
      }

      alert("RI value updated successfully!"); // ✅ Alert before updating UI
      myBookingsList();
      // 🔄 Immediately update UI to replace dropdown with text
      setBookingList((prevBookings) =>
        prevBookings.map((booking) =>
          booking.booking_group_id === bookingGroupId
            ? { ...booking, ri_value: selectedRi }
            : booking
        )
      );
    } catch (error) {
      console.error("Error updating RI value:", error);
      alert("Error updating RI value.");
    }
  };

    const [selectedRole, setSelectedRole] = useState("");
  const [appStatus, setAppStatus] = useState("");
  
  // 🔹 Role → App Status Mapping
  const roleToStatusMap = {
    RI: "Waiting for Remarks",
    AO: "waiting for AO approval",
    Secretary: "waiting for comm-sec approval",
    CAO: "Waiting for CAO verification approval",
    "CAO-AO": "Waiting for CAO-AO Approval",
  };
  
  // 🔹 Handle Role Change
  const handleRoleChange = (e) => {
    const role = e.target.value;
    setSelectedRole(role);
    setAppStatus(roleToStatusMap[role] || "");
  };
  
  // 🔹 Updated Reassign API Call
  const handleReassign = async () => {
    if (!selectedRole) {
      alert("Please select a role to reassign.");
      return;
    }
  
    try {
      const response = await fetch(`${host}/reassign`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          booking_group_id: selectedBooking.booking_group_id,
          remarks: refundReason,
          added_by: userRole, // logged in role
          reassign_to: selectedRole,
          app_status: appStatus, // 🔹 now we pass the correct app_status automatically
        }),
      });
  
      const data = await response.json();
      if (response.ok) {
        alert(data.message);
        setShowDiscountModal(false);
      } else {
        alert(data.message || "Failed to reassign");
      }
    } catch (error) {
      console.error("Error reassigning:", error);
      alert("Something went wrong");
    }
  };

  const [totalPageCount, setTotalPageCount] = useState(1);

  const bookingSummary = () => {};

  useEffect(() => {
    // myBookingsList();
    myBookingsListCallback();
  }, [currentPage]);
  // const onChangeLocation = () => {
  //   myBookingsList();
  //   // populateAvailableRoomsInCalender(moment(nextDates[0]).format("DD-MMM-YYYY"));
  //   //checkAvailability();
  // };

  const [filters, setFilters] = useState({
    checkInDate: "",
    bookingDate: "",
    customerName: "",
    venueName: "",
    app_status: "",
  });

  // const handleFilterChange = (e) => {
  //   setFilters({ ...filters, [e.target.name]: e.target.value });
  // };
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setCurrentPage(1); // optional: reset to first page on filter change
  };

  // const filteredBookings = bookingList.filter((rm) => {
  //   return (
  //     (!filters.checkInDate ||
  //       moment(rm.date).format("DD-MMM-YYYY") ===
  //         moment(filters.checkInDate).format("DD-MMM-YYYY")) && // Filter by check-in date
  //     (!filters.bookingDate ||
  //       moment(rm.booking_date).format("DD-MMM-YYYY") ===
  //         moment(filters.bookingDate).format("DD-MMM-YYYY")) && // Filter by booking date
  //     (!filters.customerName ||
  //       rm.customer_name
  //         .toLowerCase()
  //         .includes(filters.customerName.toLowerCase())) &&
  //     (!filters.venueName ||
  //       rm.room_names
  //         .toLowerCase()
  //         .includes(filters.venueName.toLowerCase())) &&
  //     // (!filters.status || rm.status.toString() === filters.status) &&
  //     (!filters.app_status ||
  //       (rm.app_status || "")
  //         .toLowerCase()
  //         .includes(filters.app_status.toLowerCase()))
  //   );
  // });


    const filteredBookings = bookingList.filter((rm) => {
  return (
    (!filters.checkInDate ||
      rm.dates?.split(",").some(
        (d) =>
          moment(d).format("DD-MMM-YYYY") ===
          moment(filters.checkInDate).format("DD-MMM-YYYY")
      )) &&
    (!filters.bookingDate ||
      moment(rm.booking_date).format("DD-MMM-YYYY") ===
        moment(filters.bookingDate).format("DD-MMM-YYYY")) &&
    (!filters.customerName ||
      rm.customer_name
        ?.toLowerCase()
        .includes(filters.customerName.toLowerCase())) &&
   (!filters.venueName ||
      [
        rm.room_names,
        rm.accommodation_type
      ]
        .map((val) =>
          val?.toLowerCase()
            .replace(/['’]/g, "") // remove apostrophes
            .trim()
        )
        .some((val) =>
          val?.includes(
            filters.venueName.toLowerCase().replace(/['’]/g, "").trim()
          )
        )) &&
    (!filters.app_status ||
      (rm.app_status || "")
        .toLowerCase()
        .includes(filters.app_status.toLowerCase()))
  );
});
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const paginatedFilteredBookings = filteredBookings.slice(
    startIndex,
    endIndex
  );
  return (
    <div>
      <Header />
      {/* <Navbar /> */}
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-lg-2"></div> */}
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  content_back">
            <div className="row">
              <b>Booking Details</b>
            </div>

            <div className="filter-container">
              <div className="filter-item">
                <label>Event Date:</label>
                <input
                  type="date"
                  name="checkInDate"
                  value={filters.checkInDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="filter-item">
                <label>Booking Date:</label>
                <input
                  type="date"
                  name="bookingDate"
                  value={filters.bookingDate}
                  onChange={handleFilterChange}
                />
              </div>

              <div className="filter-item">
                <label>Customer Name:</label>
                <input
                  type="text"
                  name="customerName"
                  value={filters.customerName}
                  onChange={handleFilterChange}
                  placeholder="Enter Customer Name"
                />
              </div>

              <div className="filter-item">
                <label>Venue Name:</label>
                <input
                  type="text"
                  name="venueName"
                  value={filters.venueName}
                  onChange={handleFilterChange}
                  placeholder="Enter Venue Name"
                />
              </div>

              <div className="filter-item">
                <label>Status:</label>
                <input
                  type="text"
                  name="app_status"
                  value={filters.app_status}
                  onChange={handleFilterChange}
                  placeholder="Enter Status"
                />
              </div>
            </div>
            <div className="row" style={{ overflowX: "auto" }}>
              <table className="table table-striped responsive-table">
                <thead>
                  <tr
                    className="data-row-head"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    <th>S No</th>
                    <th>Venue Details</th>
                    <th>Venue Name</th>
                    <th>Event Date</th>
                    <th>Contact Name</th>
                    <th>Contact No</th>
                    {/* <th>Booking Status</th> */}
                    <th>Amount</th>
                     <th>Payment Id</th>
                    <th>Payment Mode</th>
                    {/* {userRole == 1 && <th>Admin Blocked</th>}
                    {userRole == 1 && <th>Purpose</th>}
                    {userRole == 1 && <th>File URL</th>} */}
                    {/* {(userRole == 1 || userRole == 2) && <th>Admin Blocked</th>} */}
                    {(userRole == 1 || userRole == 2) && <th>Type of Event</th>}
                    {(userRole == 1 || userRole == 2) && <th>Document</th>}
                    <th>Receipt</th>
                    <th>Actions</th>
                    <th>Cancellation Reason</th>
                    <th>Refund Amount</th>

                    {(userRole == 1 || userRole == 2) && (
                      <th>Refund process</th>
                    )}
                    {(userRole == 1 || userRole == 2) && (
                      <th>electricityAttachment</th>
                    )}
                    {(userRole == 1 || userRole == 2) && (
                      <th>damagedAttachment</th>
                    )}
                    {(userRole == 1 || userRole == 2) && <th>Refund status</th>}
                      {(userRole == 1 || userRole == 2) && <th>Reassign Status</th>}
                       {(userRole == 1 || userRole == 2) && <th>Discount Applicable</th>}
                        {(userRole == 1 || userRole == 2) && <th>RI Discount Remarks</th>}
                      {(userRole == 1 || userRole == 2) &&   <th>discount amount</th>}
                   {(userRole == 1 || userRole == 2) && <th>refund amount</th>}
                  </tr>
                </thead>
                <tbody style={{ whiteSpace: "nowrap" }}>
                  {paginatedFilteredBookings.map((rm, index) => (
                    <tr key={rm.booking_group_id} className={`data-row-data ${
    rm.app_status?.toLowerCase() == "refund successfully approved"
      ? "refund-success"
      : ""
  }`}>
                      <td style={{ textAlign: "center" }}>
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {rm.accommodation_type}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.room_names}</td>
                      {/* <td style={{ textAlign: "center" }}>
                        {moment(rm.date).format("DD-MMM-YYYY")}
                      </td> */}
   {/* <td style={{ textAlign: "center" }}>
  {rm.from_date && rm.to_date
    ? `${moment(rm.from_date).format("DD-MMM-YYYY")} to ${moment(rm.to_date).format("DD-MMM-YYYY")}`
    : "-"}
</td> */}
<td style={{ textAlign: "center" }}>
  {rm.dates
    ? (() => {
        const arr = rm.dates.split(",").map(d => moment(d).format("DD-MMM-YYYY"));
        return arr.length === 1 ? arr[0] : `${arr[0]} to ${arr[arr.length - 1]}`;
      })()
    : "-"}
</td>



                      <td style={{ textAlign: "center" }}>
                        {rm.customer_name}
                      </td>
                      <td style={{ textAlign: "center" }}>{rm.contact_no}</td>

                      <td style={{ textAlign: "center" }}>{rm.sub_total}</td>
                         <td style={{ textAlign: "center" }}>{rm.razorpay_payment_id}</td>
                      <td style={{ textAlign: "center" }}>{rm.payment_mode}</td>

                      {/* Purpose (For userRole 1 & 2) */}
                      {(userRole == 1 || userRole == 2) && (
                        <td>{rm.purpose}</td>
                      )}

                      {/* File URL (Only for userRole 1) */}
                      {userRole == 1 && (
                        <td>
                          {rm.file_url && (
                            <button
                              onClick={() => handleViewDocument(rm.file_url)}
                              className="view-document-button"
                            >
                              View
                            </button>
                          )}
                        </td>
                      )}

                      <td style={{ textAlign: "center" }}>
                        {userRole !== 1 && !rm.is_blocked && (
                          <i
                            className="fa-solid fa-download"
                            onClick={() => summaryView(rm.booking_group_id)}
                          ></i>
                        )}
                      </td>

                      <td>
                        <button
                          onClick={() => handleCancelClick(rm)}
                          disabled={rm.cancelDisabled || rm.status === 2} // Disable if already canceled
                          className={
                            "view-document-button " + rm.cancelDisabled ||
                            rm.status === 2
                              ? "disabledButton"
                              : ""
                          }
                          style={{
                            padding: "6px",
                            background: "#d20909e8",
                            border: "none",
                            borderRadius: "4px",
                            color: "#fff",
                          }}
                        >
                          {rm.status === 2 ? "Canceled" : "Cancel"}
                        </button>
                      </td>

                      {/* Cancellation Reason */}
                      <td>{rm.cancellation_reason}</td>
                      <td>{rm.refund_total}</td>

                      {(userRole == 1 || userRole == 2) && (
                        <td>
                          {rm.discount}{" "}
                          {/* <button
                            className="edit-button"
                            onClick={() => openDiscountModal(rm)}
                            style={{
                              cursor: "pointer",
                              background: "blue",
                              color: "white",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              marginLeft: "5px",
                            }}
                          >
                            Refund process
                          </button> */}
                          <button
                            className="edit-button"
                            onClick={() => openDiscountModal(rm)}
                            disabled={
                              rm.app_status !== "waiting for comm-sec approval"
                            } // Button disabled if rm.app !== status
                            style={{
                              cursor:
                                rm.app_status ===
                                "waiting for comm-sec approval"
                                  ? "pointer"
                                  : "not-allowed",
                              background:
                                rm.app_status ===
                                "waiting for comm-sec approval"
                                  ? "blue"
                                  : "gray",
                              color: "white",
                              border: "none",
                              padding: "5px 10px",
                              borderRadius: "4px",
                              marginLeft: "5px",
                              opacity:
                                rm.app_status ===
                                "waiting for comm-sec approval"
                                  ? 1
                                  : 0.5, // Reduce opacity when disabled
                            }}
                          >
                            Verify and Approve
                          </button>
                        </td>
                      )}
                      {(userRole == 1 || userRole == 2) && (
                        <td style={{ textAlign: "center" }}>
  {rm.reviews &&
  rm.reviews.length > 0 &&
  rm.reviews[0].electricityAttachment ? (
    rm.reviews[0].electricityAttachment
      .split(",")
      .map((url, index) => (
        <a
          key={index}
          href={url.trim()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", marginBottom: "4px" }}
        >
          View {index + 1}
        </a>
      ))
  ) : (
    ""
  )}
</td>

                      )}

                      {(userRole == 1 || userRole == 2) && (
                       <td style={{ textAlign: "center" }}>
  {rm.reviews &&
  rm.reviews.length > 0 &&
  rm.reviews[0].damagedAttachment ? (
    rm.reviews[0].damagedAttachment
      .split(",")
      .map((url, index) => (
        <a
          key={index}
          href={url.trim()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "block", marginBottom: "4px" }}
        >
          View {index + 1}
        </a>
      ))
  ) : (
    ""
  )}
</td>

                      )}
                      {(userRole == 1 || userRole == 2) && (
                        <td>{rm.app_status}</td>
                      )}
                         {(userRole == 1 || userRole == 2) && (
                        <td>{rm.reassign_status}</td>
                      )}
                         {(userRole == 1 || userRole == 2) && (
                        <td>{rm.ri_applicable}</td>
                      )}
                        {(userRole == 1 || userRole == 2) && (
                        <td>{rm.ri_discount_remarks}</td>
                      )}

                      {(userRole == 1 || userRole == 2) && (
                        <td>{rm.discount_amount}</td>
                      )}  
                      {(userRole == 1 || userRole == 2) && (
                                            <td>
  {rm?.app_status === "Refund Successfully Approved"
    ? rm?.refund_details?.[0]?.refund_amount || "-"
    : "-"}
</td>
                      )}  
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {showModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <h3>Reason for Cancellation</h3>
                  <textarea
                    value={cancellationReason}
                    onChange={(e) => setCancellationReason(e.target.value)}
                    placeholder="Enter reason for cancellation"
                    rows="4"
                    style={{ width: "100%" }}
                  />
                  <div style={{ marginTop: "10px" }}>
                    <button
                      onClick={handleModalSubmit}
                      style={{ marginRight: "10px" }}
                    >
                      Submit
                    </button>
                    <button onClick={handleModalClose}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

            {showPopup && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <h3>Allot To RI</h3>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI1"
                      checked={selectedRI === "RI1"}
                      onChange={() => setSelectedRI("RI1")}
                    />
                    <label className="form-check-label">RI1</label>
                  </div>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI2"
                      checked={selectedRI === "RI2"}
                      onChange={() => setSelectedRI("RI2")}
                    />
                    <label className="form-check-label">RI2</label>
                  </div>
                  <div class="form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      value="RI3"
                      checked={selectedRI === "RI3"}
                      onChange={() => setSelectedRI("RI3")}
                    />
                    <label className="form-check-label">RI3</label>
                  </div>
                  <div className="popup-buttons">
                    {/* <button onClick={handleApproval} className="approveButton">
                      Approve
                    </button> */}

                    <button
                      type="button"
                      onClick={handleApproval}
                      className="approveButton"
                    >
                      Approve
                    </button>

                    <button onClick={closePopup} className="cancelButton">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showDiscountModal && selectedBooking && (
              <div className="popup-overlay">
                <div className="popup-content">
                  <h3>Apply Discount</h3>
                  <p>
                    <strong>Name:</strong> {selectedBooking.customer_name}
                  </p>
                  <p>
                    <strong>Mobile No:</strong> {selectedBooking.contact_no}
                  </p>
                  <p>
                    <strong>Amount:</strong> Rs.{selectedBooking.sub_total}
                  </p>

                  <label>Discount Percentage (%):</label>
                  <input
                    type="number"
                    value={discountPercentage}
                    onChange={(e) => setDiscountPercentage(e.target.value)}
                    min="0"
                    max="100"
                  />

                  <label>Reason:</label>
                  <textarea
                    value={discountReason}
                    onChange={(e) => setDiscountReason(e.target.value)}
                  />

                  <div className="popup-buttons">
                    <button
                      onClick={handleApplyDiscount}
                      className="approveButton"
                    >
                      Apply Discount
                    </button>
                    <button
                      onClick={() => setShowDiscountModal(false)}
                      className="cancelButton"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {isModalOpen && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Approve Booking</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={closeModal}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>

                    {/* Second Line: Customer Name, Phone, Email */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Third Line: Tabular Format for Rent, GST, etc. */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Purpose & Proof Attachment */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Type of Event &nbsp;:</strong>
                        </span>
                        <span>&nbsp; {selectedBooking.purpose || "N/A"}</span>
                      </div>
                    </div>

                    {selectedBooking.file_url && (
                      <div className="row">
                        <div className="col-12">
                          <span>
                            <strong>Attachment of Proof &nbsp;:</strong>
                          </span>
                          <a href={selectedBooking.file_url} target="_blank">
                            &nbsp; view
                          </a>
                        </div>
                      </div>
                    )}

                    {/* Assigned to RI */}
                    <div className="row">
                      <div className="col-12">
                        <span>
                          <strong>Assigned to &nbsp;:</strong>
                        </span>
                        <span>
                          &nbsp; {selectedBooking.ri_value || "Not Assigned"}
                        </span>
                      </div>
                    </div>

                    {/* Checkbox Confirmation */}
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="confirmCheck"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="confirmCheck"
                      >
                        I have checked and confirmed that the above information
                        is correct.
                      </label>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={() =>
                        handleApprove(selectedBooking.booking_group_id)
                      }
                      disabled={!isChecked}
                      className="approve-btn"
                    >
                      Approve
                    </button>
                    <button onClick={closeModal} className="cancel-btn">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showCancelModal && selectedItem && (
              <div className="modal-overlay">
                <div className="modal-container">
                  <div className="modal-header">
                    <h2 className="modal-title">Cancel Booking</h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => setShowCancelModal(false)}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* Booking Details */}{" "}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedItem.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedItem.email || "N/A"}
                        </span>
                      </div>
                    </div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedItem.total_rent}</td>
                          <td>₹{selectedItem.total_gst}</td>
                          <td>₹{selectedItem.total_security_deposit}</td>
                          <td>₹{selectedItem.total_cleaning_charges}</td>
                          <td>₹{selectedItem.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>
                    {/* Cancellation Reason */}
                    <div className="row">
                      <div className="col-12">
                        <label>
                          <strong>Cancellation Reason</strong>
                        </label>
                        <textarea
                          value={cancelReason}
                          onChange={(e) => setCancelReason(e.target.value)}
                          className="popup-textarea"
                          placeholder="Enter reason"
                          rows={4}
                          style={{ width: "100%", height: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={handleCancelClick1}
                      className="approve-btn"
                    >
                      Confirm Cancellation
                    </button>
                    <button
                      onClick={() => setShowCancelModal(false)}
                      className="cancel-btn"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* refund */}
            {showDiscountModal && selectedBooking && (
              <div className="modal-overlay">
                <div className="modal-container">
                  {/* Modal Header */}
                  <div className="modal-header">
                    <h2 className="modal-title">Approve Refund </h2>
                    <button
                      type="button"
                      className="close-btn"
                      onClick={() => setShowDiscountModal(false)}
                    >
                      ✖
                    </button>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-content">
                    {/* Venue & Event Details */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Venue :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.accommodation_type || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Venue Type :</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.room_names || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Event Date :</strong>
                        </p>
                        <span className="roomnames">
                          {moment(selectedBooking.date).format("DD-MMM-YYYY")}
                        </span>
                      </div>
                    </div>

                    {/* Customer Info */}
                    <div className="row">
                      <div className="col-4">
                        <p>
                          <strong>Name:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.customer_name || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Phone:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.contact_no || "N/A"}
                        </span>
                      </div>
                      <div className="col-4">
                        <p>
                          <strong>Email:</strong>
                        </p>
                        <span className="roomnames">
                          {selectedBooking.email || "N/A"}
                        </span>
                      </div>
                    </div>

                    {/* Charges Table */}
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Rent</th>
                          <th>GST</th>
                          <th>Security Deposit</th>
                          <th>Cleaning Charges</th>
                          <th>Total Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>₹{selectedBooking.total_rent}</td>
                          <td>₹{selectedBooking.total_gst}</td>
                          <td>₹{selectedBooking.total_security_deposit}</td>
                          <td>₹{selectedBooking.total_cleaning_charges}</td>
                          <td>₹{selectedBooking.sub_total}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="row">
                      <div className="col-3">
                        <label>Refund Amount</label>
                        {selectedBooking.refund_details &&
                        selectedBooking.refund_details.length > 0 ? (
                          selectedBooking.refund_details.map(
                            (refund, index) => (
                              <input
                                key={index}
                                type="text"
                                value={`₹${refund.refund_amount || 0}`}
                                readOnly
                                className="popup-input"
                                style={{ width: "100%" }}
                              />
                            )
                          )
                        ) : (
                          <p>No refund amount</p>
                        )}
                      </div>

                      {/* Right Section - Discount Display */}
                      <div className="col-4">
                        <label>
                          <strong>Discount Amount</strong>
                        </label>
                        <input
                          type="text"
                          value={`₹${selectedBooking.discount_amount || 0}`}
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                          }}
                        />
                      </div>

                      <div className="col-4">
                        <label>
                          <strong>Total Refund Amount</strong>
                        </label>
                        <input
                          type="text"
                          value={`₹${
                            (selectedBooking.refund_details?.reduce(
                              (acc, refund) =>
                                acc + Number(refund.refund_amount || 0),
                              0
                            ) || 0) +
                            (Number(selectedBooking.discount_amount) || 0)
                          }`}
                          readOnly
                          className="popup-input"
                          style={{
                            backgroundColor: "#f0f0f0",
                            fontWeight: "bold",
                            width: "100%",
                          }}
                        />
                      </div>
                    </div>

                    {/* ================= Remarks Section ================= */}
                    <div className="row mt-3">
                      <div className="col-12">
                        <h6 style={{ marginBottom: "8px", color: "#007bff" }}>
                          Remarks
                        </h6>

                        <div
                          style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "10px",
                            background: "#f9f9f9",
                          }}
                        >
                          {(() => {
                            const allRemarks = [];

                            if (selectedBooking?.refund_details?.length) {
                              selectedBooking.refund_details.forEach((r) => {
                                allRemarks.push({
                                  role: "AO",
                                  date: r.refunded_at,
                                  comment: r.refund_reason,
                                });
                              });
                            }

                            if (selectedBooking?.cao_remarks?.length) {
                              selectedBooking.cao_remarks.forEach((r) => {
                                allRemarks.push({
                                  role: "CAO",
                                  date: r.created,
                                  comment: r.cao_remarks,
                                });
                              });
                            }

                            if (selectedBooking?.cao_ao_remarks?.length) {
                              selectedBooking.cao_ao_remarks.forEach((r) => {
                                allRemarks.push({
                                  role: "CAO-AO",
                                  date: r.created,
                                  comment: r.cao_ao_remarks,
                                });
                              });
                            }

                            if (selectedBooking?.commisioner_remarks?.length) {
                              selectedBooking.commisioner_remarks.forEach(
                                (r) => {
                                  allRemarks.push({
                                    role: "Secretary",
                                    date: r.created,
                                    comment: r.sec_remarks,
                                  });
                                }
                              );
                            }

                            if (selectedBooking?.reviews?.length) {
                              selectedBooking.reviews.forEach((r) => {
                                allRemarks.push({
                                  role: "RI",
                                  date: r.created,
                                  comment: r.remark,
                                });
                              });
                            }

                            return allRemarks.length > 0 ? (
                              allRemarks
                                .sort(
                                  (a, b) => new Date(b.date) - new Date(a.date)
                                )
                                .map((remark, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      marginBottom: "10px",
                                      paddingBottom: "8px",
                                      borderBottom: "1px dashed #ccc",
                                    }}
                                  >
                                    <p style={{ margin: "0 0 4px" }}>
                                      <strong>
                                        {moment(remark.date).format(
                                          "DD-MMM-YYYY"
                                        )}
                                        , {remark.role}
                                      </strong>
                                    </p>
                                    <p style={{ margin: 0 }}>
                                      {remark.comment || "N/A"}
                                    </p>
                                  </div>
                                ))
                            ) : (
                              <p>No remarks available</p>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                    {/* ================================================== */}

                    {/* Total Refund Calculation */}
                    <div className="row">
                      <div className="col-8">
                        <label>
                          <strong>Remarks</strong>
                        </label>
                        <textarea
                          value={refundReason}
                          onChange={(e) => setRefundReason(e.target.value)}
                          className="popup-textarea"
                          placeholder="Enter remarks"
                          rows={4}
                          style={{ width: "100%", height: "66px" }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Modal Actions */}
                  <div className="modal-actions">
                    <button
                      onClick={handleProcessRefund}
                      className="approve-btn"
                    >
                      Approve Refund
                    </button>
                    {/* <button
                      onClick={() => setShowDiscountModal(false)}
                      className="cancelButton"
                    >
                      Cancel
                    </button> */}

                      <select
  value={selectedRole}
  onChange={handleRoleChange}
  className="popup-input"
>
  <option value="">-- Select Role to Reassign --</option>
  <option value="RI">RI</option>
  <option value="AO">AO</option>
  <option value="Secretary">Secretary</option>
  <option value="CAO">CAO</option>
  <option value="CAO-AO">CAO-AO</option>
</select>

{/* 🔹 Show app status preview */}
{appStatus && (
  <p style={{ marginTop: "6px", fontStyle: "italic", color: "#666" }}>
    New Status: {appStatus}
  </p>
)}

<button onClick={handleReassign} className="cancelButton">
  Reassign
</button>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-2"></div>
            <div className="pagination">
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span
                style={{ paddingTop: "15px" }}
              >{`Page ${currentPage} of ${totalPageCount}`}</span>
              <button
                className="btn-next-my"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPageCount}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBookings;
